import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Loader } from '@citrus/loader';
import { Header } from '@citrus/layout';
import { PrimaryButton, SecondaryButton } from '@citrus/button';
import { SelectStatic } from '@citrus/input-select';
import { ZeroState } from '@citrus/zero-state';
import { Drawer } from '@citrus/drawer';
import { Card } from '@citrus/card';
import CitrusFormViewer from "../Common/Components/citrusFormViewer/citrusFormViewer";
import * as VideoApiService from '../Common/Services/VideoApiService';
import { isNullOrEmpty } from '@pcty/utils';


class FormDrawer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isOpen: true,
      selectedFormTemplateId: undefined,
      selectedFormTemplate: {}
    };
  }


  UNSAFE_componentWillReceiveProps(nextProps) {
    let formId = undefined;

    if (nextProps.params.formId && parseInt(nextProps.params.formId) > 0) {
      formId = nextProps.params.formId;
    }

    if (nextProps.templates && nextProps.templates.length > 0 && formId) {
      // templates are loaded so we need to set the selected for the param value
      let selectedTemplates = nextProps.templates.filter(x => x.id === parseInt(formId));
      if (selectedTemplates && selectedTemplates.length > 0) {
        this.updateState(formId, selectedTemplates[0]);
      }
    } else {
      this.updateState();
    }
    this.setState({ isOpen: true });
  }

  updateState(formId = undefined, selectedFormTemplate = {}) {
    this.setState({ selectedFormTemplateId: formId });
    this.setState({ selectedFormTemplate: selectedFormTemplate });
  }

  UNSAFE_componentWillMount() {
    let companyId = this.props.params.companyId;
    let employeeId = this.props.params.employeeId;
    let formTypeId = this.props.params.formTypeId;

    let moduleId = this.getOptionValue("moduleId");
    this.props.loadFormTemplates(companyId, employeeId, formTypeId, moduleId);
  }

  closeDrawer() {
    this.setState({ isOpen: false });
  }

  onSelectedTemplateChange(id, value, text) {
    let template = {};

    if (value && value.length > 0) {
      template = this.props.templates.filter(x => {
        return x.id === parseInt(value);
      })[0];
    }

    this.setState({ selectedFormTemplate: template });
    this.setState({ selectedFormTemplateId: value });
  }

  handleCancelClick() {
    var evt = new CustomEvent('PctyTalentFormDrawerCancel', { detail: this.props.params });
    window.dispatchEvent(evt);
    this.closeDrawer();
  }

  handleApplyClick() {
    var evt = new CustomEvent('PctyTalentFormDrawerApply', { detail: this.state.selectedFormTemplate });
    window.dispatchEvent(evt);
    this.closeDrawer();
  }

  isOptionEnabled(option) {
    return this.props.options && this.props.options[option];
  }

  getOptionValue(option) {
    let value = (this.props.options && this.props.options[option]) ? this.props.options[option] : undefined;
    return value;
  }

  onGetViewVideoToken(companyId, videoId, isPublicForm) {
    if (!isNullOrEmpty(videoId)) {
     return VideoApiService.getSingleViewToken(companyId, videoId, isPublicForm);
    }
  };

  renderTemplateTypeSelection() {
    let templates = this.isOptionEnabled('hideFormsWithNoQuestions') ? this.props.templates.filter(t => t.questionCount > 0) : this.props.templates;
    templates = templates.map(item => {
      return { value: item.id.toString(), label: item.templateName };
    });
    const selectedTemplate = this.state.selectedFormTemplateId ? templates.find(x => x.value === this.state.selectedFormTemplateId) : null;

    return <div className="pcty-row">
      <div className="pcty-col-xs-12" style={{ marginLeft: '15px', marginRight: '25px' }}>
        <Loader loading={this.props.isLoading} global={true} />

        <div className="pcty-row margin-bottom pcty-border-bottom" style={{ backgroundColor: '#EAEAEA' }}>
          <div className="pcty-col-xs-12" style={{ marginTop: '15px', marginBottom: '15px' }}>
            <h3>Previewing</h3>
            <SelectStatic
              automationId="availableTemplates"
              id="availableTemplates"
              onChange={(item, id) => this.onSelectedTemplateChange(id, item.value, item.label)}
              options={templates}
              placeholder="Select Template..."
              style={{ width: '625px' }}
              value={selectedTemplate} />
          </div>
        </div>

        {this.state.selectedFormTemplateId &&
          <div className="pcty-row">
            <div className="pcty-col-xs-12" style={{ marginTop: '15px', paddingRight: '45px' }}>
              <Card header="Preview" automationId="card1">
                <CitrusFormViewer
                displayMode={'preview'}
                formName={this.state.selectedFormTemplate.templateName}
                configuration={this.state.selectedFormTemplate.configuration}
                onGetViewVideoToken={(videoId) => this.onGetViewVideoToken(this.props.params.companyId, videoId, false)}
                />
              </Card>
            </div>
          </div>
        }
        {!this.state.selectedFormTemplateId &&
          <div style={{ marginTop: '100px' }}>
            <ZeroState type="takeaction" message={"No template selected. Pick one from the dropdown list to preview it."} />
          </div>
        }
      </div>
    </div>
  }


  render() {
    const renderActionArea = () =>
      <React.Fragment>
        <SecondaryButton automationId="drawer-cancel"
          onClick={() => this.handleCancelClick()}>Cancel</SecondaryButton>
        <PrimaryButton automationId="drawer-apply"
          disabled={!this.state.selectedFormTemplateId}
          onClick={() => this.handleApplyClick()}>Use This Form</PrimaryButton>
      </React.Fragment>;

    return (
      <Drawer id="form-template-drawer"
        onClose={() => this.handleCancelClick()}
        open={this.state.isOpen}
        position="right"
        size="large">
        <Header id="form-template-drawer-title"
          title="Preview Form"
          renderActionArea={renderActionArea} />
        {this.renderTemplateTypeSelection()}
      </Drawer>
    )
  };

}


FormDrawer.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  params: PropTypes.object.isRequired,
  loadFormTemplates: PropTypes.func.isRequired,
  templates: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default FormDrawer;
